

export enum abtest_SBSPage25Variants {
    //Today's default
    oldY = 0,
    sideBySide = 1,
    ultimateOnly


}


export interface SubscriptionsVM {
    subscriptionPlans: SubscriptionPlanModel[];
    products: ProductModel[];
    sbsIncludedIn:number;
}

export interface SubscriptionPlanModel {
    tierName: string;
    tierLowHigh: string;
    skU_MSRP: number;
    skuPrice: number;
    isPriceDifferent:boolean;
    skuName: string;
    skuNumber: string;
    documentUrlPath: string;
    tagline: string;
    sbsTypeID: number;
    skuid: number;
    numberOfFreeDays:number;
    rating: number;
    reviewsTotal:number;
}

export interface ProductModel {
    documentName: string;
    isLow: number;
    isHigh: number;
    thumb: string;
    documentPageDescription: string;
    documentUrlPath: string;
    reviewsTotal: number | null;
    rating: number | null;
    sortPopular: number;
    sortIncludes: number;
    skuInStoreFrom: string;
}
export interface SoftwareCodeAlert {
    key:number;
    title:string;
}
export interface SbsActiveTier {
    itemOrder:number;
    tierName:string;
}
export interface SoftwareCodesReponse {
    sbsIncludedIn: number;
    productCount: number;
    productName: string;
    thumb: string;
}
